import { RG_TYPE, GetAllMuscles } from "@project-rouge/rg-core";
import { Vector3 } from "three";
const objectsWithMuscleID = [RG_TYPE.Apartment, RG_TYPE.Core, RG_TYPE.TechnicalSpace, RG_TYPE.Entrance];
function getSortedChildrenPerMuscle(building, level) {
  const sortedPerMuscle = [];
  const muscleChildren = building.children.filter((child) => objectsWithMuscleID.includes(child.type) && child.data.level === level).filter((child) => child.data.muscleID);
  const childrenPerMuscle = {};
  muscleChildren.forEach((child) => {
    if (!childrenPerMuscle[child.data.muscleID]) {
      childrenPerMuscle[child.data.muscleID] = [];
    }
    childrenPerMuscle[child.data.muscleID].push(child);
  });
  const muscles = GetAllMuscles(building.data.anatomy);
  for (const muscle of muscles) {
    if (!childrenPerMuscle[muscle.id])
      continue;
    const childrenOfMuscle = childrenPerMuscle[muscle.id];
    childrenOfMuscle.sort((a, b) => distance2Muscle(b, muscle) - distance2Muscle(a, muscle));
    sortedPerMuscle.push({ muscle, children: childrenOfMuscle });
  }
  return sortedPerMuscle;
}
function distance2Muscle(obj, muscle) {
  const pointA = new Vector3(...obj.pos);
  const pointB = muscle.flip ? new Vector3(...muscle.points[1]) : new Vector3(...muscle.points[0]);
  return pointA.distanceToSquared(pointB);
}
export {
  getSortedChildrenPerMuscle
};
//# sourceMappingURL=index16.js.map
